import { DeleteOutlined } from '@ant-design/icons'
import { Popconfirm } from 'antd'
import * as React from 'react'
import type { DeleteRateButtonProps } from '../types'
import { GraviButton } from '@gravitate-js/excalibrr'
import { useRateManagement } from '../hooks'

/**
 * Component for deleting a point-to-point rate
 */
export function DeleteRateButton({ rate, pointToPoint, onSuccess, setPointToPoint }: DeleteRateButtonProps) {
  const { deleteRate } = useRateManagement(pointToPoint, setPointToPoint, onSuccess)

  const handleDeleteRate = async () => {
    await deleteRate(rate)
  }

  return (
    <Popconfirm
      title='Delete Scheduled Rate'
      description='Are you sure you want to delete this scheduled rate?'
      onConfirm={handleDeleteRate}
      okText='Yes'
      cancelText='No'
      okButtonProps={{ danger: true }}
    >
      <GraviButton error icon={<DeleteOutlined />} />
    </Popconfirm>
  )
}
